import React, { useImperativeHandle, forwardRef, useState } from 'react';
import { ApiSearch } from '@assets/js/api/commonApi.js';

const CompFormVeCmptnDtl = forwardRef((props, ref) => {
    const [params, setParams] = useState({});
    const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(false);

    /****************************
     * Define required variables
    *****************************/
    const rootId = 'modalCompetitionDetail';

    /*************************
     * Define react functions
    **************************/
    // Forward ref to allow parent components to call event functions.
    useImperativeHandle(ref, () => ({
        modalToggle(p_params) {
            handleToggle();
            setParams(p_params || {});
            if (p_params && p_params.comptnCd) {
                onSearchForm(p_params.mngCd, p_params.comptnCd);
            }
        },
    }));

    /**********************
     * Define functions
    ***********************/
    const handleToggle = () => {
        const targetEle = document.querySelector('#' + rootId);
        if (targetEle) {
            targetEle.style.display = targetEle.style.display === 'none' ? 'block' : 'none';
        }

        // 모달이 닫힐 때 데이터 초기화
        if (targetEle && targetEle.style.display === 'none') {
            setFormData(null);
        }
    }

    // 대회별 폼 정보 조회
    const onSearchForm = (mngCd, comptnCd) => {
        setLoading(true);

        ApiSearch('/ve/competition/form/search/info', { mngCd: mngCd, comptnCd: comptnCd }).then(res => {
            if (res && res.success && res.data) {
                setFormData(res.data.data || {});
            }
            setLoading(false);
        }).catch(error => {
            console.error('Error fetching competition form:', error);
            setLoading(false);
        });
    }

    return (
        <>
            <div
                className="modal modal-sheet p-1 py-md-5"
                style={{ display: 'none', backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
                tabIndex={-1}
                role="dialog"
                id={rootId}
            >
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content rounded-4 shadow">
                        <div className="modal-header border-bottom-0">
                            <h1 className="modal-title fs-3"><b>대회 상세정보</b></h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={handleToggle}
                            />
                        </div>
                        <div className="modal-body py-0">
                            <div className="row">
                                <div className="col-lg-12">
                            {loading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {/* 기본 대회 정보 */}
                                    <div className="mb-4">
                                        <h6 className="border-bottom pb-2 mb-3" style={{
                                            fontSize: '1.1rem',
                                            fontWeight: '700',
                                            color: '#0d6efd',
                                            borderColor: '#0d6efd !important',
                                            borderWidth: '2px !important',
                                            background: 'linear-gradient(135deg, #e7f1ff 0%, #f0f7ff 100%)',
                                            padding: '0.75rem 1rem',
                                            borderRadius: '8px',
                                            marginBottom: '1rem'
                                        }}>
                                            <i className="bi bi-info-circle-fill me-2"></i>
                                            기본 정보
                                        </h6>
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <label className="form-label fw-bold">대회명</label>
                                                <p className="form-control-plaintext">{params.comptnNm || '-'}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-bold">대회 기간</label>
                                                <p className="form-control-plaintext">
                                                    {params.strtDate === params.endDate ? (params.strtDate == null ? '' : params.strtDate) : params.strtDate + ' ~ ' + params.endDate}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* 대회 상세 정보 */}
                                    {formData && (
                                        <div className="mb-4">
                                            <h6 className="border-bottom pb-2 mb-3" style={{
                                                fontSize: '1.1rem',
                                                fontWeight: '700',
                                                color: '#198754',
                                                borderColor: '#198754 !important',
                                                borderWidth: '2px !important',
                                                background: 'linear-gradient(135deg, #d1f4e0 0%, #e8f9f0 100%)',
                                                padding: '0.75rem 1rem',
                                                borderRadius: '8px',
                                                marginBottom: '1rem'
                                            }}>
                                                <i className="bi bi-trophy-fill me-2"></i>
                                                대회 정보
                                            </h6>
                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <label className="form-label fw-bold">신청 시작일</label>
                                                    <p className="form-control-plaintext">{formData.strtDate || '-'}</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label fw-bold">신청 마감일</label>
                                                    <p className="form-control-plaintext">{formData.deadDate || '-'}</p>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <label className="form-label fw-bold">대회 상금</label>
                                                    <p className="form-control-plaintext">{formData.winPrizeExpn || '-'}</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label fw-bold">대회 장소</label>
                                                    <p className="form-control-plaintext">{formData.locExpn || '-'}</p>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-6">
                                                    <label className="form-label fw-bold">대회 참가비</label>
                                                    <p className="form-control-plaintext">{formData.partFeeExpn || '-'}</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <label className="form-label fw-bold">대회 일시</label>
                                                    <p className="form-control-plaintext">{formData.dateExpn || '-'}</p>
                                                </div>
                                            </div>
                                            <div className="row mb-3">
                                                <div className="col-md-12">
                                                    <label className="form-label fw-bold">대회 일정</label>
                                                    <p className="form-control-plaintext">{formData.schlExpn || '-'}</p>
                                                </div>
                                            </div>
                                            {formData.remark && (
                                                <div className="row mb-3">
                                                    <div className="col-md-12">
                                                        <label className="form-label fw-bold">비고</label>
                                                        <p className="form-control-plaintext">{formData.remark}</p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )}

                                    {/* 대회 설명 */}
                                    {params.description && (
                                        <div className="mb-3">
                                            <h6 className="border-bottom pb-2 mb-3" style={{
                                                fontSize: '1.1rem',
                                                fontWeight: '700',
                                                color: '#6c757d',
                                                borderColor: '#6c757d !important',
                                                borderWidth: '2px !important',
                                                background: 'linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%)',
                                                padding: '0.75rem 1rem',
                                                borderRadius: '8px',
                                                marginBottom: '1rem'
                                            }}>
                                                <i className="bi bi-file-text-fill me-2"></i>
                                                대회 설명
                                            </h6>
                                            <p className="form-control-plaintext" style={{ whiteSpace: 'pre-wrap' }}>
                                                {params.description}
                                            </p>
                                        </div>
                                    )}
                                </>
                            )}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer flex-nowrap p-0">
                            <button
                                type="button"
                                className="btn btn-lg btn-link fs-6 text-decoration-none col-12 py-3 m-0 rounded-0"
                                onClick={handleToggle}
                                style={{
                                    color: '#ffffff',
                                    background: 'linear-gradient(135deg, #0d6efd 0%, #0056d2 100%)',
                                    borderTop: '1px solid #0d6efd'
                                }}
                            >
                                <strong>닫기</strong>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default CompFormVeCmptnDtl;
